var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto overflow-hidden"},[_c('topmenu',{attrs:{"route":_vm.route}}),_c('sidemenu'),_c('v-card-text',[_c('calendario',{attrs:{"route":_vm.route}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }